import { render, staticRenderFns } from "./OssBatchUploadPage.vue?vue&type=template&id=1839d54c&scoped=true"
import script from "./OssBatchUploadPage.vue?vue&type=script&lang=js"
export * from "./OssBatchUploadPage.vue?vue&type=script&lang=js"
import style0 from "./OssBatchUploadPage.vue?vue&type=style&index=0&id=1839d54c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1839d54c",
  null
  
)

export default component.exports